import { render, staticRenderFns } from "./AccountTopHeader.vue?vue&type=template&id=13543b52&scoped=true"
import script from "./AccountTopHeader.vue?vue&type=script&lang=js"
export * from "./AccountTopHeader.vue?vue&type=script&lang=js"
import style0 from "./AccountTopHeader.vue?vue&type=style&index=0&id=13543b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13543b52",
  null
  
)

export default component.exports